module.exports = __webpack_public_path__ + "64f886b232962979e2eaf29d93108286.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-semibold-italic.ttf
// module id = 1544
// module chunks = 0